module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-pages"
  }, [_c('div', {
    staticClass: "hero-pages__desktop"
  }, [_c('div', {
    staticClass: "hero-pages__bg",
    style: ("background-image: url(" + _vm.props.background_image + ");")
  }, [_c('div', {
    staticClass: "hero-pages__container"
  }, [_c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.scrolled
      }),
      expression: "{ active: true, callback: scrolled}"
    }],
    staticClass: "hero-pages__waypoint"
  }), _c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypointTitle,
        options: _vm.intersectionTitleOptions
      }),
      expression: "{ active: true, callback: onWaypointTitle, options: intersectionTitleOptions }"
    }],
    staticClass: "hero-pages__title",
    class: {
      "hero-pages__title--active": _vm.fadeTitle
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), (_vm.props.button) ? _c('a', {
    staticClass: "hero-pages__button",
    domProps: {
      "innerHTML": _vm._s(_vm.props.button)
    },
    on: {
      "click": function($event) {
        _vm.showComplimentaryModal = true
      }
    }
  }) : _vm._e()])]), _c('transition', {
    attrs: {
      "name": "fade-in-modal"
    }
  }, [_c('ComplimentaryExamForm', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showComplimentaryModal),
      expression: "showComplimentaryModal"
    }],
    on: {
      "closeComplimentaryModal": function($event) {
        _vm.showComplimentaryModal = false
      }
    }
  })], 1)], 1), _c('div', {
    staticClass: "hero-pages__mobile"
  }, [_c('div', {
    staticClass: "hero-pages__bg",
    style: ("background-image: url(" + _vm.props.mobile_background + ");")
  }, [_c('div', {
    staticClass: "hero-pages__container"
  }, [_c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.scrolled
      }),
      expression: "{ active: true, callback: scrolled}"
    }],
    staticClass: "hero-pages__waypoint"
  }), _c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypointTitle,
        options: _vm.intersectionTitleOptions
      }),
      expression: "{ active: true, callback: onWaypointTitle, options: intersectionTitleOptions }"
    }],
    staticClass: "hero-pages__title",
    class: {
      "hero-pages__title--active": _vm.fadeTitle
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), (_vm.props.button) ? _c('a', {
    staticClass: "hero-pages__button",
    domProps: {
      "innerHTML": _vm._s(_vm.props.button)
    },
    on: {
      "click": function($event) {
        _vm.showComplimentaryModal = true
      }
    }
  }) : _vm._e()])]), _c('transition', {
    attrs: {
      "name": "fade-in-modal"
    }
  }, [_c('ComplimentaryExamForm', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showComplimentaryModal),
      expression: "showComplimentaryModal"
    }],
    on: {
      "closeComplimentaryModal": function($event) {
        _vm.showComplimentaryModal = false
      }
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6559d269","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/hero/hero-pages/hero-pages.pug
// module id = 584
// module chunks = 1